<template>
    <div class="text-center">
        <i :class="icon"></i>
   </div>
</template>
<script>
export default {
        props: ['value'],
        computed: {
            icon: function () {
                if (this.value == true) {
                    return "fa fa-check";
                } else {
                    return "fa fa-times";
                }
            }
        }
}
</script>

<style scoped>
.text-center{
    text-align: center;
}
</style>
